<div class="toast-content" [ngClass]="{'toastAction': open}">
  <div class="toast-message f15 tc" [ngClass]="notify?.type">
    {{notify?.msg}}
  </div>
</div>
